import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { ArrowLeft, Clock3 } from 'lucide-react';

const featureNames: Record<string, string> = {
  random: '随机组卷',
  'mooc-topics': 'MOOC 按分类做题',
  'mooc-random': '随机 MOOC',
};

const CSCAUpcoming: React.FC = () => {
  const { examLevel, feature } = useParams();
  if ((examLevel !== '1' && examLevel !== '2') || !feature || !featureNames[feature]) {
    return <Navigate to="/" replace />;
  }

  const isScience = examLevel === '2';
  const homePath = `/csca/simulation/${examLevel}`;
  const subject = isScience ? '中文理科（IPA）' : '中文文科（IPS）';
  const color = isScience ? 'text-emerald-800' : 'text-orange-800';
  const surface = isScience ? 'border-emerald-100 bg-emerald-50' : 'border-orange-100 bg-orange-50';

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <Link to={homePath} className={`inline-flex items-center gap-2 text-sm font-bold ${color}`}><ArrowLeft className="h-4 w-4" /> 返回本科目</Link>
      <section className={`rounded-3xl border p-8 text-center shadow-sm md:p-12 ${surface}`}>
        <div className={`mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-white ${color}`}><Clock3 className="h-8 w-8" /></div>
        <p className={`mt-6 text-sm font-extrabold uppercase tracking-[0.18em] ${color}`}>CSCA {subject}</p>
        <h1 className="mt-3 text-4xl font-black text-slate-900">Upcoming</h1>
        <p className="mt-3 text-lg font-bold text-slate-700">{featureNames[feature]}即将开放</p>
        <p className="mt-2 text-sm text-slate-500">您可以先练习已开放的试卷和题型。</p>
        <Link to={homePath} className={`mt-7 inline-flex rounded-xl bg-white px-5 py-3 text-sm font-bold shadow-sm ${color}`}>查看本科目</Link>
      </section>
    </div>
  );
};

export default CSCAUpcoming;
